import React from "react";
import { CheckCircle, AlertCircle, Clock, Wrench } from "lucide-react"; // ícones modernos

export default function Tabela({ dados = [], carregando = false }) {
  // 🎨 Define cor e ícone conforme o status
  const getEstiloStatus = (status) => {
    const s = status?.toLowerCase() || "";
    if (s.includes("finalizado") || s.includes("concluído")) {
      return { cor: "#1e7f14", icone: <CheckCircle size={16} /> }; // Verde
    } else if (s.includes("pendente")) {
      return { cor: "#b50000", icone: <AlertCircle size={16} /> }; // Vermelho
    } else if (s.includes("atendendo")) {
      return { cor: "#007bff", icone: <Wrench size={16} /> }; // Azul
    } else if (s.includes("aberto")) {
      return { cor: "#f5a623", icone: <Clock size={16} /> }; // Laranja
    }
    return { cor: "#454545", icone: <AlertCircle size={16} /> }; // Padrão
  };

  return (
    <div
      className="bg-white mt-6 border border-gray-200"
      style={{
        borderRadius: "6px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.12)",
        overflow: "hidden",
      }}
    >
      <table className="w-full text-left border-collapse">
        <thead className="bg-[#f95000] text-white">
          <tr>
            <th className="px-4 py-3 text-sm font-semibold" style={{ fontFamily: "Comfortaa, cursive" }}>
              Data Abertura
            </th>
            <th className="px-4 py-3 text-sm font-semibold" style={{ fontFamily: "Comfortaa, cursive" }}>
              Data Finalizado
            </th>
            <th className="px-4 py-3 text-sm font-semibold" style={{ fontFamily: "Comfortaa, cursive" }}>
              Empresa
            </th>
            <th className="px-4 py-3 text-sm font-semibold" style={{ fontFamily: "Comfortaa, cursive" }}>
              Solicitado por
            </th>
            <th className="px-4 py-3 text-sm font-semibold" style={{ fontFamily: "Comfortaa, cursive" }}>
              Tipo de Serviço
            </th>
            <th className="px-4 py-3 text-sm font-semibold" style={{ fontFamily: "Comfortaa, cursive" }}>
              Técnico Responsável
            </th>
            <th
              className="px-4 py-3 text-sm font-semibold text-center"
              style={{ fontFamily: "Comfortaa, cursive" }}
            >
              Status
            </th>
          </tr>
        </thead>

        <tbody>
          {carregando ? (
            <tr>
              <td colSpan="7" className="text-center py-6 text-gray-500" style={{ fontFamily: "Comfortaa, cursive" }}>
                Carregando chamados...
              </td>
            </tr>
          ) : dados.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center py-6 text-gray-500" style={{ fontFamily: "Comfortaa, cursive" }}>
                Nenhum registro encontrado.
              </td>
            </tr>
          ) : (
            dados.map((item, index) => {
              const { cor, icone } = getEstiloStatus(item.status);
              return (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition-colors"
                  style={{ color: "#454545", fontFamily: "Comfortaa, cursive" }}
                >
                  <td className="px-4 py-3 border-t">
                    {item.data_abertura ? item.data_abertura.split("-").reverse().join("/") : "-"}
                  </td>
                  <td className="px-4 py-3 border-t">
                    {item.finalizado_em ? item.finalizado_em.split("-").reverse().join("/") : "-"}
                  </td>
                  <td className="px-4 py-3 border-t">{item.empresa}</td>
                  <td className="px-4 py-3 border-t">{item.colaborador}</td>
                  <td className="px-4 py-3 border-t">{item.tipo_servico}</td>
                  <td className="px-4 py-3 border-t">{item.tecnico_responsavel}</td>
                  <td className="px-4 py-3 border-t font-semibold text-center">
                    <div
                      className="flex items-center justify-center gap-2"
                      style={{ color: cor }}
                    >
                      {item.status || "-"}
                      <span className="ml-1">{icone}</span>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
